import axios from "axios";

const FEES_BASE_URL = "https://m8b55qcovf.execute-api.ap-south-1.amazonaws.com/Test/student";

// A dedicated instance instead of the shared `axios` default export — src/
// config.js sets organization-id/session-id on axios.defaults.headers.common
// globally for the staff app, and axios.create() still inherits whatever is
// on that object at creation time, so they're explicitly stripped back out
// below (this doesn't touch the global defaults — axios deep-clones headers
// into a new object on create()). This external FABS fee endpoint (AWS API
// Gateway, not this app's own Laravel backend) 401s without this fixed
// Bearer token (2026-10-30) — it's a static credential for this endpoint,
// not a per-user session token.
const feesApi = axios.create({
  headers: {
    accept: "application/json",
    Authorization: "Bearer lPPC7njhW8VBJhg7AhhsbfCnmYh",
  },
});
delete feesApi.defaults.headers.common["organization-id"];
delete feesApi.defaults.headers.common["session-id"];

export const getFeeDetail = (admissionNumber) => {
  return feesApi.get(`${FEES_BASE_URL}/${admissionNumber}`);
};
